export default __webpack_public_path__ + "static/media/CustomManageCompanyPerks.75f7579c.png";